import {mapGetters} from "vuex";
// import Form5Controller from "@/controllers/Organizations/Form5Controller";
export const fiveFormsMixin ={
    computed: {
        ...mapGetters('spr', {
            get_spr_data_usl_loading: 'getUslsStatus',
            get_spr_data_usl_error: 'getUsls',
        }),
    },
    methods: {

    },
}